import React from "react";

interface CardGradientProps {
  className?: string;
  width?: string | number;
  height?: string | number;
}

const ReferralsIcon: React.FC<CardGradientProps> = ({
  className,
  width = "14",
  height = "19",
}) => {
  return (
    <svg
    width={width}
      height={height}
      className={className}
      viewBox="0 0 14 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 17C12 14.2386 9.76142 12 7 12C4.23858 12 2 14.2386 2 17L12 17Z"
        fill="#FFA686"
        stroke="#FFA686"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle
        cx="7.00098"
        cy="7"
        r="5"
        transform="rotate(90 7.00098 7)"
        stroke="#CFB2FF"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ReferralsIcon;
